import { useEffect, useState } from "react";
import { useUserService } from "../../service/user/index";
import { IUser } from "../../service/user/interfaces/IUser";

const useGetUserById = (id: string) => {
  const { getUserById } = useUserService();
  const [data, setData] = useState<IUser>();
  const [error, setError] = useState<any>();
  const [isLoading, setIsLoading] = useState<Boolean>(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          setIsLoading(true);
          const response = await getUserById(id);
          setData(response.data);
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return {
    data,
    error,
    isLoading,
  };
};

export default useGetUserById;
